import React, { useState } from "react";
import './staff-modules.css';

const SAMPLE_RESOURCES = [
  {
    id: 1,
    title: "Fundamentals of Nursing",
    type: "Book",
    author: "Potter & Perry",
    link: "https://www.example.com/fundamentals-nursing",
    description: "Comprehensive reference for nursing basics."
  },
  {
    id: 2,
    title: "Clinical Procedures Handbook",
    type: "PDF",
    author: "GNM College",
    link: "https://www.example.com/clinical-procedures",
    description: "Step-by-step guide for clinical skills and procedures."
  },
  {
    id: 3,
    title: "Pharmacology Lecture Notes",
    type: "Notes",
    author: "Dr. S. Mehta",
    link: "",
    description: "Handwritten notes covering all major pharmacology topics."
  }
];

export default function Library() {
  const [resources, setResources] = useState(SAMPLE_RESOURCES);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({
    title: "",
    type: "",
    author: "",
    link: "",
    description: ""
  });

  const handleInputChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (!form.title || !form.type || !form.author) return;
    setResources([
      { ...form, id: Date.now() },
      ...resources
    ]);
    setForm({ title: "", type: "", author: "", link: "", description: "" });
    setShowForm(false);
  };

  return (
    <div className="module-wrapper">
      <h2>Library & Resources</h2>
      <p>
        Browse and share reference books, lecture notes, and teaching resources. Upload useful files or external links for staff and students.
      </p>
      <div className="module-actions">
        <button className="primary-action" onClick={() => setShowForm((s) => !s)}>
          {showForm ? "Cancel" : "Add Resource"}
        </button>
      </div>
      {showForm && (
        <form className="resource-form" onSubmit={handleFormSubmit}>
          <div className="form-row">
            <label htmlFor="title">Title:</label>
            <input name="title" id="title" value={form.title} onChange={handleInputChange} required />
          </div>
          <div className="form-row">
            <label htmlFor="type">Type:</label>
            <select name="type" id="type" value={form.type} onChange={handleInputChange} required>
              <option value="">--Select--</option>
              <option value="Book">Book</option>
              <option value="PDF">PDF</option>
              <option value="Notes">Notes</option>
              <option value="Link">External Link</option>
              <option value="Other">Other</option>
            </select>
          </div>
          <div className="form-row">
            <label htmlFor="author">Author:</label>
            <input name="author" id="author" value={form.author} onChange={handleInputChange} required />
          </div>
          <div className="form-row">
            <label htmlFor="link">Resource Link (optional):</label>
            <input name="link" id="link" value={form.link} onChange={handleInputChange} />
          </div>
          <div className="form-row">
            <label htmlFor="description">Description:</label>
            <textarea name="description" id="description" value={form.description} onChange={handleInputChange} rows={2} />
          </div>
          <button type="submit" className="primary-action">Add Resource</button>
        </form>
      )}
      <div className="resources-list">
        {resources.length === 0 && (
          <div className="empty-message">No resources available.</div>
        )}
        {resources.map((res) => (
          <div className="resource-card" key={res.id}>
            <div className="resource-header">
              <span className="resource-title">{res.title}</span>
              <span className="resource-type">{res.type}</span>
            </div>
            <div className="resource-desc">{res.description}</div>
            <div className="resource-meta">
              <span>By: {res.author}</span>
              {res.link && (
                <a href={res.link} target="_blank" rel="noopener noreferrer" className="resource-link">
                  View Resource
                </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}